import { render, staticRenderFns } from "./BaseMultipleSelect.global.vue?vue&type=template&id=88c86048&scoped=true&"
import script from "./BaseMultipleSelect.global.vue?vue&type=script&lang=js&"
export * from "./BaseMultipleSelect.global.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultipleSelect.global.vue?vue&type=style&index=0&id=88c86048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c86048",
  null
  
)

export default component.exports